import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/GLB_OXXO_Objetos Exterior.glb"
import { GUI } from "dat.gui";
import gsap from "gsap";

export class OutdoorOxxo extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Bote_Basura = gltf.scene.getObjectByName("Bote_Basura", true);
			this.Escoba = gltf.scene.getObjectByName("Escoba", true);
			this.Recogedor = gltf.scene.getObjectByName("Recogedor", true);
			this.Bolsa_Basura = gltf.scene.getObjectByName("Bolsa_Basura", true);
		});
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill()
			this.animation = null
			this.Bote_Basura.material.emissiveIntensity = 1
			this.Bote_Basura.material.emissive.set("#000")
			this.Escoba.material.emissiveIntensity = 1
			this.Escoba.material.emissive.set("#000")
			this.Recogedor.material.emissiveIntensity = 1
			this.Recogedor.material.emissive.set("#000")
			this.Bolsa_Basura.material.emissiveIntensity = 1
			this.Bolsa_Basura.material.emissive.set("#000")
		}
	}

	onChangueMaterial(object) {
		const newMaterial = object.material.clone();
		newMaterial.transparent = true
		newMaterial.emissive.set("#404040");
		object.material = newMaterial
	}

	onAnimateMultipleEmissieve(objects = []) {
		this.clearAnimation()

		if (objects.length === 0) {
			return
		}

		const objMaterials = objects.map((obj) => {
			this.onChangueMaterial(obj)
			return obj.material
		})

		this.animation = gsap.to(objMaterials, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("oxxo exterior");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.scale, "x", -2, 2).step(0.0001).name("scale X");
		premiaFolder.add(this.scale, "y", -2, 2).step(0.0001).name("scale Y");
		premiaFolder.add(this.scale, "z", -2, 2).step(0.0001).name("scale Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	helpersChild() {
		this.helperMethod("Bote_Basura", this.Bote_Basura);
		this.helperMethod("Escoba", this.Escoba);
		this.helperMethod("Recogedor", this.Recogedor);
		this.helperMethod("Bolsa_Basura", this.Bolsa_Basura);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -10, 10).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -10, 10).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -10, 10).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}


	renderAnimations() { }
}
